// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MapOverlay_overlay__2hiaB","content":"MapOverlay_content__1rU8r"};